export const getClassNameLocalLogRowForTable = (idLogType: number): string => {
    switch (true) {
        case idLogType === -11:
        case idLogType === -6:
        case idLogType === -5:
        case idLogType === -4:
        case idLogType === -3:
        case idLogType === -2:
        case idLogType === -1:
        case (idLogType >= 1 && idLogType <= 10):
            return 'table-row-color-orange'
        case (idLogType >= 11 && idLogType <= 20):
            return 'table-row-color-lightblue'
        case (idLogType >= 21 && idLogType <= 40):
            return 'table-row-color-red';
        case (idLogType >= 41 && idLogType <= 60):
            return 'table-row-color-lightblue';
        default:
            return '';
    }
}